import type { ComponentProps } from 'react';

import OnboardingVerification from '@/features/onboarding/verification';

type VerificationPageProps = ComponentProps<typeof OnboardingVerification>;

const VerificationPage = (props: VerificationPageProps) => {
  return <OnboardingVerification {...props} />;
};
VerificationPage.displayName = 'VerificationPage';

export default VerificationPage;
